import "@fortawesome/fontawesome-free/css/all.css";
import "font-awesome/css/font-awesome.min.css";
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { VuetifyConfig } from "@/plugins/configs/VuetifyConfig";

Vue.use(Vuetify);

export default new Vuetify(VuetifyConfig);
